import { useQuery } from "react-query";
import { getAssessments } from "../services/school/assessment/getAssessments";
import { PagedRequestType } from "../types/PagedResults";
import { key_assessments, key_studentsClasses } from "../utils/constants";
import { getStudentsFromClass } from "../services/school/student/getStudentsFromClass";

export const useGetStudentClassesQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [key_studentsClasses, JSON.stringify(data)],
    () => getStudentsFromClass(data),
    options?{...options}:{}

  );